import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ChatIcon from '@mui/icons-material/Chat';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ComputerIcon from '@mui/icons-material/Computer';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DevicesIcon from '@mui/icons-material/Devices';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import EditIcon from '@mui/icons-material/Edit';
import EventIcon from '@mui/icons-material/Event';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FlagIcon from '@mui/icons-material/Flag';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import GavelIcon from '@mui/icons-material/Gavel';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import StarIcon from '@mui/icons-material/Star';
import SyncIcon from '@mui/icons-material/Sync';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import TimelineIcon from '@mui/icons-material/Timeline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import React from 'react';
import styled from 'styled-components';

export enum IconName {
  Lock = 'Lock',
  LockOpen = 'LockOpen',
  Flag = 'Flag',
  MonetizationOn = 'MonetizationOn',
  EventNote = 'EventNote',
  AccessTime = 'AccessTime',
  CheckCircle = 'CheckCircle',
  Cancel = 'Cancel',
  CalendarToday = 'CalendarToday',
  Person = 'Person',
  Star = 'Star',
  Business = 'Business',
  Money = 'Money',
  Timeline = 'Timeline',
  Event = 'Event',
  Gavel = 'Gavel',
  Sync = 'Sync',
  People = 'People',
  Computer = 'Computer',
  Devices = 'Devices',
  Chat = 'Chat',
  Edit = 'Edit',
  Arrow = 'Arrow',
  ChatBubble = 'ChatBubble',
  FormatQuote = 'FormatQuote',
  Info = 'Info',
  Visibility = 'Visibility',
  TaskAlt = 'TaskAlt',
  CancelOutlined = 'CancelOutlined',
  HourglassEmptyOutlined = 'HourglassEmptyOutlined',
  DoneAllOutlined = 'DoneAllOutlined',
  HandshakeOutlined = 'HandshakeOutlined',
  PauseCircleOutlined = 'PauseCircleOutlined',
  HourglassTopOutlined = 'HourglassTopOutlined',
  BlockOutlined = 'BlockOutlined',
  DeleteOutline = 'DeleteOutline',
  Check = 'Check',
  Warning = 'Warning',
}

interface DynamicIconProps {
  iconName: IconName;
  size?: 'small' | 'medium' | 'large';
  usePrimaryColor?: boolean;
}

const StyledIcon = styled.span<{ size: 'small' | 'medium' | 'large' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white svg {
    font-size: ${(props) => {
      switch (props.size) {
        case 'small':
          return '16px';
        case 'medium':
          return '24px';
        case 'large':
          return '42px';
        default:
          return '24px';
      }
    }};
  }
`;

const DynamicIcon: React.FC<DynamicIconProps> = ({ iconName, usePrimaryColor, size = 'medium' }) => {
  const iconMap = {
    Lock: LockIcon,
    LockOpen: LockOpenIcon,
    Flag: FlagIcon,
    MonetizationOn: MonetizationOnIcon,
    EventNote: EventNoteIcon,
    AccessTime: AccessTimeIcon,
    CheckCircle: CheckCircleIcon,
    Cancel: CancelIcon,
    CalendarToday: CalendarTodayIcon,
    Person: PersonIcon,
    Star: StarIcon,
    Business: BusinessIcon,
    Money: MoneyIcon,
    Timeline: TimelineIcon,
    Event: EventIcon,
    Gavel: GavelIcon,
    Sync: SyncIcon,
    People: PeopleIcon,
    Computer: ComputerIcon,
    Devices: DevicesIcon,
    Chat: ChatIcon,
    Edit: EditIcon,
    Arrow: ArrowForwardIcon,
    ChatBubble: ChatBubbleOutlineIcon,
    FormatQuote: FormatQuoteIcon,
    Info: InfoIcon,
    Visibility: VisibilityIcon,
    TaskAlt: TaskAltOutlinedIcon,
    CancelOutlined: CancelOutlinedIcon,
    HourglassEmptyOutlined: HourglassEmptyOutlinedIcon,
    DoneAllOutlined: DoneAllOutlinedIcon,
    HandshakeOutlined: HandshakeOutlinedIcon,
    PauseCircleOutlined: PauseCircleOutlineOutlinedIcon,
    HourglassTopOutlined: HourglassTopOutlinedIcon,
    BlockOutlined: BlockOutlinedIcon,
    DeleteOutline: DeleteOutlineIcon,
    Check: CheckIcon,
    Warning: WarningIcon,
  };

  const IconComponent = iconMap[iconName];
  return IconComponent ? (
    <StyledIcon size={size}>
      <IconComponent sx={usePrimaryColor ? { color: '#2b90e3' } : undefined} />
    </StyledIcon>
  ) : null;
};

export default DynamicIcon;
